/*
	Action para informar à nossa store
	que nosso swagger está pronto para uso
*/
export default ({ commit }, { client, operations }) => 
	commit("swaggerIsReady", { client, operations })

